import React from "react";
import styles from "./CardFrame.module.scss";

interface CardFrameProps {
	children: React.ReactNode;
	headerSectionTitle?: string;
	headerSectionRightContent?: React.ReactNode;
	borderColor?: string;
	paddingBottom?: number;
	/** Lets content (e.g. a dropdown) escape the card's rounded-corner clipping instead of being cut off. */
	overflowVisible?: boolean;
}

export const CardFrame = ({
	children,
	headerSectionTitle,
	headerSectionRightContent,
	borderColor,
	paddingBottom,
	overflowVisible,
}: CardFrameProps) => {
	const hasHeader = headerSectionTitle != null || headerSectionRightContent != null;

	return (
		<div
			className={styles.card}
			style={{
				...(borderColor ? { borderColor } : {}),
				...(paddingBottom !== undefined ? { paddingBottom } : {}),
				...(overflowVisible ? { overflow: "visible" } : {}),
			}}
		>
			{hasHeader && (
				<div className={styles.header}>
					{headerSectionTitle && <span className={styles.headerTitle}>{headerSectionTitle}</span>}
					{headerSectionRightContent && <div className={styles.headerRight}>{headerSectionRightContent}</div>}
				</div>
			)}
			{children}
		</div>
	);
};
